import { LaunchOutlined } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import { BlockListRender, DME } from "dmeditor";
import { BlockList } from "net";
import React, { useEffect, useState } from "react";
import Moment from "react-moment";
const MyFeed = (props: DME.WidgetRenderProps) => {
  const [list, setList] = useState<null | Array<{ schools: any }>>(null);

  const [error, setError] = useState("");

  const [status, setStatus] = useState(0); // 0 - loading, 1 - annoymous, 2 - logged in

  useEffect(() => {}, []);

  return (
    <div>
      <div>
        {props.blockNode.children && (
          <BlockListRender
            blockData={props.blockNode.children}
            path={props.path}
            mode={props.mode}
          />
        )}
      </div>
    </div>
  );
};
export default MyFeed;
